import { Controller } from "@hotwired/stimulus"

// Edit balance payment: toggle manual sales tax fields when switching to/from charge or package lines.
export default class extends Controller {
    static targets = ["transactionSelect", "manualSalesTaxGroup"]

    connect() {
        this.toggleManualSalesTax()
    }

    toggleManualSalesTax() {
        if (!this.hasManualSalesTaxGroupTarget) return
        const v = this.transactionSelectTarget.value
        const hideTax = v === "charge" || v === "bought_package"
        this.manualSalesTaxGroupTarget.style.display = hideTax ? "none" : "block"
    }
}
